/*=========================================================================================
  File Name: moduleDataList.js
  Description: Indicator Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleIndicatorState.js";
import mutations from "./moduleIndicatorMutations.js";
import actions from "./moduleIndicatorActions.js";
import getters from "./moduleIndicatorGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
